import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const langfuse = defineConnector({
  identifier: "langfuse",
  name: "Langfuse",
  tagLine: "Open-source LLM observability",
  logo,
  protocol: "http",
  tags: ["ai", "engineering", "observability"],
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl || "https://cloud.langfuse.com"),
  auth: (app) =>
    basicAuth({
      username: app.secret.publicKey,
      password: app.secret.secretKey,
    }),
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In Langfuse, open your project’s **Settings › API Keys** and create a new key pair. You’ll get a public key (`pk-lf-...`) and a secret key (`sk-lf-...`).",
        },
      ],
    },
    {
      title: "Enter your Langfuse details",
      items: [
        {
          kind: "baseUrl",
          label: "Langfuse URL",
          placeholder: "https://cloud.langfuse.com",
          helperText:
            "Leave blank for Langfuse Cloud (EU). Use https://us.cloud.langfuse.com for the US region, or your self-hosted URL.",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "Public key",
          placeholder: "pk-lf-...",
          required: true,
          target: { kind: "secrets", field: "publicKey" },
        },
        {
          kind: "input",
          label: "Secret key",
          placeholder: "sk-lf-...",
          required: true,
          target: { kind: "secrets", field: "secretKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://cloud.langfuse.com"}/api/public/projects`,
  },
});
